// offline/db.js
// Base de datos local (IndexedDB vía Dexie) para el modo offline-first.
//
// Patrón heredado del SI-PIC: por cada entidad que se puede crear/editar en
// campo, DOS tablas:
//   <entidad>_pendientes -> cola de cambios sin sincronizar
//   <entidad>_cache      -> última copia conocida del servidor (lectura offline)
//
// El campo `sincronizado` en la cola tiene 4 estados:
//   0 = pendiente, se reintenta en cada sync
//   1 = ya sincronizado (se puede limpiar)
//   2 = duplicado / registro padre eliminado — descartado, no reintentar
//   3 = error de datos — reintentar solo no lo arregla; el motivo va en `ultimoError`
//
// A medida que se definan las entidades reales de Promoción Social, agregar
// aquí sus tablas _pendientes / _cache y subir la versión del schema.

import Dexie from "dexie";

export const db = new Dexie("promocion_social_offline");

db.version(1).stores({
  discapacidad_pendientes: "++id, sincronizado, _editId, createdAt",
  discapacidad_cache: "id, documento",
});

db.version(2).stores({
  listas_territorios_cache: "id, nombre",
  listas_comunidades_cache: "id, territorio, comunidad",
  listas_aatis_cache: "id, territorio, aati",
  listas_etnias_cache: "id, nombre",
  listas_eapbs_cache: "id, nombre",
});

// v3: Vejez — segunda estrategia real del sistema, mismo patrón que Discapacidad.
db.version(3).stores({
  vejez_pendientes: "++id, sincronizado, _editId, createdAt",
  vejez_cache: "id, documento",
});

// v4: Población Migrante — tercera estrategia, mismo patrón.
db.version(4).stores({
  migrante_pendientes: "++id, sincronizado, _editId, createdAt",
  migrante_cache: "id, documento",
});

// v5: Habitante de Calle — cuarta estrategia, mismo patrón.
db.version(5).stores({
  habitante_calle_pendientes: "++id, sincronizado, _editId, createdAt",
  habitante_calle_cache: "id, documento",
});

export default db;
